import React from "react";
import { Box, Card, CardBody, CardHeader, Heading, Text } from "grommet";
import { User } from "grommet-icons";
import { useUser } from "../../AuthContext";

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function getDisplayProctorName(username, email) {
  const name = (username || "").trim();
  if (!name) return "";
  if (email && name.toLowerCase() === email.toLowerCase()) return "";
  if (UUID_PATTERN.test(name)) return "";
  return name;
}

function capitalizeDisplayName(name) {
  return String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

function ProctorProfile() {
  const myUser = useUser();
  const userEmail = myUser?.user?.attributes?.email || "";
  const displayName = getDisplayProctorName(myUser?.proctorName, userEmail);
  const profileName = capitalizeDisplayName(displayName) || "Proctor";
  const profileEmail = userEmail || "Not available";

  return (
    <Box align="center" justify="start" pad="medium" fill="horizontal">
      <Box
        width={{ max: "large" }}
        fill="horizontal"
        pad={{ horizontal: "medium" }}
        gap="small"
      >
        <Heading level="3" textAlign="center" margin="none">
          Proctor Profile
        </Heading>
        <Text textAlign="center" color="text-weak">
          View and manage your proctor information.
        </Text>
        <Card
          margin={{ top: "small" }}
          pad="medium"
          round="small"
          elevation="xsmall"
          background="background-front"
        >
          <CardHeader
            align="center"
            direction="row"
            gap="small"
            pad={{ bottom: "small" }}
          >
            <User />
            <Heading level="4" margin="none">
              Profile details
            </Heading>
          </CardHeader>
          <CardBody gap="medium" align="start">
            <Box align="start" gap="xsmall">
              <Text size="small" color="text-weak">
                Name
              </Text>
              <Text>{profileName}</Text>
            </Box>
            <Box align="start" gap="xsmall">
              <Text size="small" color="text-weak">
                Email
              </Text>
              <Text>{profileEmail}</Text>
            </Box>
          </CardBody>
        </Card>
      </Box>
    </Box>
  );
}

export default ProctorProfile;
